import { Rating, View, Text } from '@aws-amplify/ui-react';

export function Balance (props) {
    //console.log("Balance props", props);

    // Pending = earned but not yet validated by gcValidate, so NOT spendable.
    // The spendable number itself is always server-computed (`spendableStars` from
    // /get-client) and never includes pending -- that is what closes the over-spend
    // hole and is not negotiable.
    //
    // Owner ruling: show the pending count in the main nav ONLY while the validated
    // balance is still zero. A brand-new user who has completed tasks would otherwise
    // just see "0" and assume the app is broken; once they have any validated stars,
    // the real balance is the meaningful number and the pending count is noise.
    // A dedicated place to inspect pending stars is a separate piece of work.
    // See docs/free-campaign-stars-and-validation.md
    const validated = Number(props.balance);
    const pending = Number(props.starsPending);
    const showPending =
        isFinite(pending) && pending > 0 &&
        (!isFinite(validated) || validated === 0);

    return (
        <View style={{whiteSpace: 'nowrap'}}>
            {(("fiatBalance" in props) && (props.fiatBalance !== undefined)) ? "$"+props.fiatBalance : ""}&nbsp;
            {props.balance}
            <Rating
            value={1}
            maxValue={1}
            fillColor="hsl(51, 100%, 50%)"
            size="small"
            />
            {showPending ? (
                <Text
                    as="span"
                    fontSize="small"
                    color="font.tertiary"
                    title="Earned, waiting on LinkedIn validation. Not spendable yet."
                >
                    &nbsp;&#9203;{pending}
                </Text>
            ) : null}
        </View>
    )
}
